import React, { useEffect } from "react";
import { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import {
  ApplicationPaths,
  QueryParameterNames,
} from "./ApiAuthorizationConstants";
import authService from "./AuthorizeService";
import tenantConfig from "../../mocks/tenantOne.json";
import { camelCase } from "lodash";
import { Error } from "../../layouts";
import permissions from "../../mocks/menuPermissions.json";
export default class AuthorizeRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      authenticated: false,
      roleName: "VOU",
    };
  }
  async checkIfIsAllowed() {
    const { menu, component, computedMatch, flow, path } = this.props;
    const subMenu = component.name;
    const pathFlow = computedMatch.params.flow
      ? computedMatch.params.flow
      : flow;
    var isAuthorised, isConfigured;
    var roleName = await authService.getRole();
    if (menu === undefined || null) {
      isConfigured = false;
    } else {
      if (menu != "home") {
        isConfigured = tenantConfig.menuItems.includes(menu) ? true : false;
        isAuthorised = isConfigured
          ? permissions[roleName].menuItems[menu]?.includes("S")
            ? true
            : false
          : false;

        if (isConfigured && subMenu != "C") {
          const subMenuControl =
            permissions[roleName][menu + "SubMenu"][camelCase(subMenu)];
          const access = subMenuControl
            ? (pathFlow == "edit" && subMenuControl.includes("R")) ||
              (pathFlow == "save" && subMenuControl.includes("U")) ||
              (pathFlow == "add" && subMenuControl.includes("C"))
            : false;
          isConfigured = tenantConfig[menu + "SubMenu"].includes(
            camelCase(subMenu)
          )
            ? true
            : false;
          isAuthorised = isConfigured ? access : false;
        }
      } else {
        isConfigured = true;
        isAuthorised = true;
      }
    }
    return isConfigured && isAuthorised;
  }
  componentDidMount() {
    this._subscription = authService.subscribe(() =>
      this.authenticationChanged()
    );
    this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  render() {
    const { ready, authenticated } = this.state;
    var link = document.createElement("a");
    link.href = this.props.path;
    const returnUrl = `${link.protocol}//${link.host}/payroll`;
    const redirectUrl = `${ApplicationPaths.Login}?${
      QueryParameterNames.ReturnUrl
    }=${encodeURI(returnUrl)}`;
    if (!ready) {
      return <div></div>;
    } else {
      const { component: Component, ...rest } = this.props;
      return (
        <Route
          {...rest}
          render={(props) => {
            if (!authenticated) {
              return <Redirect to={redirectUrl} />;
            } else if (this.checkIfIsAllowed()) {
              return <Component {...props} />;
            } else {
              return <Route component={Error} />;
            }
          }}
        />
      );
    }
  }

  async populateAuthenticationState() {
    // const authenticated = await authService.isAuthenticated();
    const authenticated = await authService.isAuthenticated();
    var user = await authService.getUser();
    this.setState({
      ...this.state,
      ready: true,
      authenticated,
      roleName: user?.role ?? "VOU",
    });
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false });
    await this.populateAuthenticationState();
  }
}
